import { http } from './config'

export default {

  getAllBayTypes: () => {
    return http.get('bay_types')
  },
  
  getFilteredBayTypes: (params) => {
    return http.get('bay_types', {params})
  },

  getBayTypesById: (bayTypesId) => {
    return http.get('bay_types/' + bayTypesId)
  },

  createBayTypesType: (bayTypesParams) => {
    return http.post('bay_types', {
      name: bayTypesParams.name,
      width: bayTypesParams.width,
      height: bayTypesParams.height,
      length: bayTypesParams.length,
    }
  )},

  updateBayTypesType: (bayTypesParams) => {
    return http.put('bay_types/' + bayTypesParams.id, {
      name: bayTypesParams.name,
      width: bayTypesParams.width,
      height: bayTypesParams.height,
      length: bayTypesParams.length,
    }
  )},

  deleteBayTypes: (bayTypesId) => {
    return http.delete('bay_types/' + bayTypesId)
  }
}
